import React from 'react';
import { FctEstado } from '../../fct/react';

/** Activo / baja con el semáforo del manual: color con icono y etiqueta, siempre. */
export const EstadoEmpleadoTag: React.FC<{ activo: boolean }> = ({ activo }) => (
  <FctEstado
    personalizado={activo
      ? { etiqueta: 'Activo', familia: 'exito', icono: 'completado' }
      : { etiqueta: 'Baja', familia: 'neutro', icono: 'cancelado' }}
  />
);
